import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "fill-width" }

import {emptyProgressInfo, ProgressInfo} from "@/shared/model/ProgressInfo";
import {ref, watch} from "vue";
import {computed} from "vue";
import SogDataLabel from "@/shared/ui/SogDataLabel.vue";
import {SogDataLabelValueType} from "@/shared/ui/types/SogDataLabelValueType";
import SogProgressBar from "@/shared/ui/SogProgressBar.vue";

interface Props {
  progressInfo?: ProgressInfo
  showCaption?: boolean
}


export default /*@__PURE__*/_defineComponent({
  __name: 'SogProgressInfoComponent',
  props: {
    progressInfo: { default: undefined },
    showCaption: { type: Boolean, default: true }
  },
  setup(__props: any) {

const _props = __props

const progress = ref(emptyProgressInfo)

watch(_props, () => {
    if (_props.progressInfo) {
      progress.value = _props.progressInfo
    } else {
      progress.value = emptyProgressInfo
    }
  }
)

function format(s: string) {
  if (s) {
    return s.replaceAll('/r/n', '<br>')
  }
}

const value = computed(() => {
  return progress.value && progress.value.progress
    ? Math.ceil(100 * progress.value.progress / (progress.value.maxProgress ? progress.value.maxProgress : 1)) : 0
})


const resultClass = computed(() => {
  return progress.value && progress.value.successful ? 'e-success' : 'e-error'
})



return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("h4", null, _toDisplayString(progress.value?progress.value.caption:""), 513), [
      [_vShow, __props.showCaption===true]
    ]),
    _withDirectives(_createElementVNode("span", null, [
      _cache[0] || (_cache[0] = _createTextVNode("started: ", -1)),
      _createVNode(SogDataLabel, {
        value: progress.value.startDate,
        "value-type": _unref(SogDataLabelValueType).DateTime
      }, null, 8, ["value", "value-type"]),
      _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1))
    ], 512), [
      [_vShow, progress.value.startDate]
    ]),
    _withDirectives(_createElementVNode("span", null, [
      _cache[2] || (_cache[2] = _createTextVNode("finished: ", -1)),
      _createVNode(SogDataLabel, {
        value: progress.value.finishDate,
        "value-type": _unref(SogDataLabelValueType).DateTime
      }, null, 8, ["value", "value-type"]),
      _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1))
    ], 512), [
      [_vShow, progress.value.finishDate]
    ]),
    _withDirectives(_createElementVNode("div", {
      class: _normalizeClass(resultClass.value)
    }, [
      _createTextVNode(_toDisplayString(progress.value?format(progress.value.resultMessage):""), 1),
      _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1))
    ], 2), [
      [_vShow, progress.value&&progress.value.resultMessage]
    ]),
    _withDirectives(_createElementVNode("div", null, [
      _createTextVNode(_toDisplayString(progress.value?progress.value.text:""), 1),
      _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1))
    ], 512), [
      [_vShow, progress.value&&progress.value.text]
    ]),
    _withDirectives(_createVNode(SogProgressBar, {
      "model-value": value.value,
      height: "25"
    }, {
      default: _withCtx(() => [
        _createElementVNode("strong", null, _toDisplayString(progress.value?progress.value.statusText:""), 1)
      ]),
      _: 1
    }, 8, ["model-value"]), [
      [_vShow, progress.value&&progress.value.maxProgress>0&&!progress.value.finishDate]
    ]),
    _withDirectives(_createVNode(SogProgressBar, { indeterminate: true }, null, 512), [
      [_vShow, progress.value.finishDate!==undefined&&(!progress.value.finishDate)]
    ])
  ], 512)), [
    [_vShow, progress.value]
  ])
}
}

})